import { Component, ErrorHandler, OnInit, } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-verify-register',
  templateUrl: './verify-register.component.html',
  styleUrls: ['./verify-register.component.css']
})
export class VerifyRegisterComponent implements OnInit {
  r: any = [];
  //r: any = {};
  data: any;
  appRegNo: any;
  id: string;
  pdId: string;
  role: string;
  Notificationid: string;
  PD_Id: string;
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {;
  }

  ngOnInit() {
     //this.r = {};
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.pdId = params['pdId'];
      this.role = params['role'];
    });
     //history.pushState(null, '', window.location.href);
    //history.replaceState(null, '', window.location.href);
    //this.GetByIdVerify(this.appRegNo,this.mobileNo);
  }



  onSubmit(verifyForm: NgForm) {
    debugger;
    if (verifyForm.valid) {
      // const appRegNo = verifyForm.value.APP_REG_NO;
      const appRegNo = verifyForm.value.appRegNo;
      this.GetByIdVerify(appRegNo);
    }
  }
  GetByIdVerify(appRegNo: any) {
    debugger;
    this.Notificationid = this.id;
    this.PD_Id = this.pdId;
    // Display the loader spinner
    document.getElementById('loader-spinner').style.display = "block";

    // Call the user service to get verification data by mobile number
    this.data = this.userService.GetByIdverification(appRegNo,this.Notificationid,this.PD_Id);

    // Subscribe to the observable returned by the service
    this.data.subscribe((response: any) => {
        this.r = response;

             console.log("Full API Response:", response);
      //  if(this.r.code === 403){
      //     swal('Warning!', response.message, 'warning');
      //  }
      //  if(this.r.code === 404){
      //    swal('Warning!', response.message, 'warning');
      //  }
      //  if(this.r.code === 405){
      //    swal('Warning!', response.message, 'warning');
      //  }
      //  if(this.r.code === 400){
      //    swal('Warning!', response.message, 'warning');
      //  }
      //  if(this.r.code === 500){
      //    swal('Warning!', response.message, 'warning');
      //  }
      //  if(this.r.code === 200){
      //    swal('Warning!', response.message, 'warning');
      //  }
        
        // Check if the response contains an error message
        if (this.r.code === 200 && this.r.message === "Applicant not registered") {
          // Show error message if the applicant is not registered
          swal('Warning!', this.r.message, 'warning');
        } 
        
        else if (this.r.code === 200 && this.r.message === "Applicant has already applied for this notification") {
          // Show error message if the applicant is not registered
          swal('Warning!', this.r.message, 'warning');
        }
         else if (this.r.code === 200 && this.r.message === "Applicant has already applied for a notification") {
          // Show error message if the applicant is not registered
          swal('Warning!', this.r.message, 'warning');
        }
        
        else {
          // Display success message using SweetAlert
          swal('Success!', 'Verified Registration Successfully.', 'success');
          
          sessionStorage.setItem('regVerified', '1');   // ← add this line
          // Prepare navigation extras with the mobile number as query params
          const navigationExtras: NavigationExtras = {
            queryParams: { data: appRegNo,
              id:this.id, pdId: this.pdId, role: this.role
             }
          };

          // Navigate to the form applicant page with query params
          // this.router.navigate(['/form-applicant'], navigationExtras);
           this.router.navigate(['/against-notification-form'], navigationExtras);
        }
        
        // Hide the loader spinner
        document.getElementById('loader-spinner').style.display = "none";
      }, 
      (error) => {
        // Handle errors
        console.error(error);
             const errBody = error.error;
             console.log(errBody);

        if (errBody && errBody.message) {
          debugger;
          // Show the actual message from your API
          if (errBody.code === 403) {
            swal('Warning!', errBody.message, 'warning');
          } else if (errBody.code === 404) {
            swal('Warning!', errBody.message, 'warning');
          } else if (errBody.code === 405) {
            swal('Warning!', errBody.message, 'warning');
          } else if (errBody.code === 400) {
            swal('Warning!', errBody.message, 'warning');
          } else if (errBody.code === 500) {
            swal('Error!', errBody.message, 'error');
          } else {
            swal('Error!', errBody.message, 'error');
          }
        }
        // Show error message
        //swal('Error!', 'An error occurred. Please try again.', 'error');

        // Hide the loader spinner on error
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
}





  // preventForward = () => {
  //   history.pushState(null, '', window.location.href);
  // }

  // ngOnDestroy() {
  //   window.removeEventListener('popstate', this.preventForward);
  // }



}




// WEBPACK FOOTER //
// ./src/app/registration/verify-register/verify-register.component.ts